'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUiTablet = exports.isUiMicrosoftBrowser = exports.getMobileBrowserOS = exports.isUiMobile = exports.getUiBrowser = undefined;
exports.default = reducer;

var _reselect = require('reselect');

// reducer
var DEFAULT_STATE = {
    deviceType: '',
    microsoftBrowser: false,
    mobile: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.browser;
};

var getUiBrowser = exports.getUiBrowser = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var isUiMobile = exports.isUiMobile = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.mobile;
});

var getMobileBrowserOS = exports.getMobileBrowserOS = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.mobile ? uiBrowser.os : '';
});

var isUiMicrosoftBrowser = exports.isUiMicrosoftBrowser = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.microsoftBrowser;
});

var isUiTablet = exports.isUiTablet = (0, _reselect.createSelector)(isUiMobile, function (mobile) {
    return mobile === 'tablet';
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/browser.js
// module id = aN2S
// module chunks = 46